export const LUNA_RESULTS_MOCK = [
  {
    id: "Articles",
    title: "Articles",
  },
  {
    id: "8th-grade",
    title: "8th grade",
  },
  {
    id: "American Revolution",
    title: "American Revolution",
  },
] as const;

export const LUNA_FILTER_PANEL_TEST_IDS = {
  CONTAINER: "luna-filter-panel-container",
  CHIP_GROUP: "search-luna-chip-group",
  CHIP_PREFIX: "chip-",
} as const;
